import { useHead } from "../services/common";

import Content from "../components/Content";

export default function Contact() {

    useHead({
        title: "Kontakt a spojení | T.J. Sokol Poniklá",
        description: "Kontaktní informace na T.J. Sokol Poniklá. Adresa, telefon, e-mail a mapa. Neváhejte nás kontaktovat s vašimi dotazy."
    });

    return <>
        <div className="header">
            <h1>Kontakt</h1>
        </div>
        <section className="width-max">
            <div className="content-box">
                <Content id="contact" />
            </div>
        </section>

        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2529.1039397533746!2d15.462018278058919!3d50.66233067163356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470ec7433412f3a5%3A0xb824bdb2f01218fe!2sPonikl%C3%A1%20204%2C%20512%2042%20Ponikl%C3%A1!5e0!3m2!1sen!2scz!4v1745321055332!5m2!1sen!2scz" width="100%" height="450" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        <div style={{ marginBottom: "-110px" }} />
    </>;
}